import routes from 'js/core_pre_webpack/routes';

export const analyticsUpgradeUrl = (
  parameters: Parameters<typeof routes.upgrade_url>[0],
): string => routes.upgrade_url(parameters);
